<script>
  import { Link } from 'svelte-routing';
  
  export let anime;
</script>

<Link to="/anime/{anime.id}" class="block">
  <div class="card hover:scale-105 transition-transform duration-300 animate-fade-in">
    <div class="relative aspect-[2/3]">
      <img 
        src={anime.coverImage} 
        alt={anime.title}
        class="w-full h-full object-cover"
      />
      <div class="absolute top-2 right-2 bg-yellow-500 text-gray-900 px-2 py-1 rounded-md text-sm font-bold">
        ⭐ {anime.rating}
      </div>
      <div class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4">
        <h3 class="text-lg font-semibold text-white truncate">{anime.title}</h3>
        <p class="text-sm text-gray-300">{anime.releaseYear} • {anime.status}</p>
      </div>
    </div>
    <div class="p-4">
      <div class="flex flex-wrap gap-2">
        {#each anime.genres.slice(0, 3) as genre}
          <span class="px-2 py-1 bg-gray-800 text-xs rounded-full text-gray-300">
            {genre}
          </span>
        {/each}
      </div>
    </div>
  </div>
</Link>
